module.exports = __webpack_public_path__ + "img/5-4.93b74c0f.png";